"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TruncatedText = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var truncate_1 = require("../../bff/lib/truncate");
function TruncatedText(_a) {
    var text = _a.text;
    var containerRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(null), truncatedText = _b[0], setTruncatedText = _b[1];
    (0, react_1.useEffect)(function () {
        if (containerRef.current) {
            /**
             * This is kinda saying 1 string character is approx 7px wide
             * This is not bulletproof. I just found that 7 works best.
             */
            var charWidth = 7;
            var stringLength = Math.ceil(containerRef.current.offsetWidth / charWidth);
            setTruncatedText((0, truncate_1.truncateMiddle)(text, stringLength));
        }
    }, [containerRef]);
    return (react_1.default.createElement(StyledContainer, { ref: containerRef }, truncatedText && react_1.default.createElement(core_ui_1.Text, { display: "inline" }, truncatedText)));
}
exports.TruncatedText = TruncatedText;
var StyledContainer = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n"], ["\n  display: block;\n  width: 100%;\n"])));
var templateObject_1;
